import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { withInMemoryScrolling, withRouterConfig, provideRouter } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { withInterceptorsFromDi, provideHttpClient, withFetch } from '@angular/common/http';
import { QuicklinkModule } from 'ngx-quicklink';
import { provideTranslocoRoot } from './app.transloco.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, provideClientHydration, withEventReplay, withNoIncrementalHydration } from '@angular/platform-browser';
import { RIVE_VERSION } from 'ng-rive';
import { REGION_OR_DOMAIN, FIREBASE_CONFIG, FIRESTORE_SETTINGS } from 'ngfire/tokens';
import { createErrorHandler } from '@sentry/angular';
import env from '@env';

const SENTRY_ERROR_HANDLER = env.production
  ? [{
    provide: ErrorHandler,
    useValue: createErrorHandler({ showDialog: false }),
  }]
  : [];

export default {
  providers: [
    provideTranslocoRoot(),
    importProvidersFrom(
      BrowserModule,
      QuicklinkModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: env.production,
        registrationStrategy: 'registerWhenStable',
      })
    ),
    { provide: REGION_OR_DOMAIN, useValue: 'europe-west1' },
    {
      provide: FIREBASE_CONFIG,
      useValue: env.firebaseConfig,
    },
    { provide: FIRESTORE_SETTINGS, useValue: { experimentalAutoDetectLongPolling: true } },
    { provide: RIVE_VERSION, useValue: '1.1.4' },
    ...SENTRY_ERROR_HANDLER,
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAnimations(),
    provideRouter([
      {
        path: '',
        loadChildren: () => import("./buyer/shell.routes"),
      },
      {
        path: 's',
        loadChildren: () => import("./seller/shell.routes"),
      },
      {
        path: 'print',
        loadChildren: () => import("./print/print.routes")
      },
      {
        path: 'admin',
        loadChildren: () => import("./admin").then(m => m.routes)
      },
      {
        path: '**',
        data: { animation: 'dialog' },
        loadChildren: () => import("./home/not-found/not-found.module").then((m) => m.NotFoundModule),
      },
    ],
      withInMemoryScrolling({ anchorScrolling: 'disabled' }),
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
  ]
}
